import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, useMediaQuery, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import useTranslation from "../../hooks/useTranslation";

const useStyles = (theme, isMobile) => ({
  back: {
    background: "linear-gradient(107deg, #011e52, #01122f 100%)",
    color: theme.palette.white.main,
    width: "230px",
    height: "65px",
    borderRadius: "100px",
    display: "flex",
    justifyContent: "space-evenly",
    fontFamily: theme.typography.montserrat.regular,
  },
  icon: {
    p: "5px",
    height: "14px",
    width: "14px",
    borderRadius: "58px",
    color: theme.palette.blue.main,
    bgcolor: theme.palette.white.main,
    ml: "3px",
    boxShadow:
      "4px 8px 20px 0 rgba(0, 0, 0, 0.15), inset 7px 0 20px 0 rgba(255, 255, 255, 0.15)",
  },
  typography: {
    title: {
      color: "#868686",
      fontFamily: theme.typography.montserrat.regular,
      fontSize: "16px",
    },
  },
});

const BackButton = () => {
  const isMobile = useMediaQuery("(max-width:899px)");
  const theme = useTheme();
  const classes = useStyles(theme, isMobile);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { title } = useTranslation(pathname, "BackButton");

  return isMobile ? (
    <Typography
      sx={{
        color: "#858585",
        fontSize: "14px",
        mt: "30px",
        fontFamily: theme.typography.montserrat.regular,
        textDecoration: "underline",
        cursor: "pointer",
      }}
      onClick={() => navigate(-1)}
    >
      Volver
    </Typography>
  ) : (
    <Button
      sx={classes.back}
      startIcon={<ArrowBackIosNewIcon sx={classes.icon} />}
      onClick={() => navigate(-1)}
    >
      {title}
    </Button>
  );
};

export default BackButton;
